/* eslint-disable */ import { assertNumber, dragHandleComponent, draggableComponent, memoEval, sceneEntityDeleteFabComponent, sceneEntitySelectHotspotComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const wallItemComponents = [
    attachComponent.withComponent(sceneEntitySelectHotspotComponent, 'default', true).withAlias('WallItem').withFilter(()=>({
            navigationStates: [
                'RoomContent',
                'Recipes'
            ],
            modes: [
                'owner'
            ]
        })).attach(memoEval((self)=>[
            self.$selectHotspotOffsetX,
            self.$selectHotspotOffsetY,
            self.$selectHotspotOffsetZ
        ], ($selectHotspotOffsetX, $selectHotspotOffsetY, $selectHotspotOffsetZ)=>({
            offsetX: $selectHotspotOffsetX,
            offsetY: $selectHotspotOffsetY,
            offsetZ: $selectHotspotOffsetZ,
            hideWhileDragging: true
        }))),
    attachComponent.withComponent(sceneEntityDeleteFabComponent, 'default', true).withAlias('WallItem').withFilter(()=>({
            modes: [
                'owner'
            ]
        })).attach(memoEval((self)=>[
            self.$selectHotspotOffsetX,
            self.$selectHotspotOffsetY,
            self.$selectHotspotOffsetZ
        ], ($selectHotspotOffsetX, $selectHotspotOffsetY, $selectHotspotOffsetZ)=>({
            offsetX: $selectHotspotOffsetX,
            offsetY: $selectHotspotOffsetY,
            offsetZ: $selectHotspotOffsetZ
        }))),
    attachComponent.withComponent(draggableComponent, 'dragging', true).withAlias('WallItem').withFilter((s)=>s.$draggableFilter).attach(memoEval((self)=>[
            self.x
        ], (x)=>({
            x: x,
            y: 0,
            z: 0
        })), (state)=>{
        assertNumber(state.x);
        return {
            x: state.x
        };
    }),
    attachComponent.withComponent(dragHandleComponent, 'dragging', true).withAlias('WallItem').withFilter((s)=>s.$draggableFilter).attach(memoEval((self)=>[
            self.$surfaces
        ], ($surfaces)=>({
            surfaces: $surfaces,
            target: 'dragging'
        })))
];

//# sourceMappingURL=wall-item.js.map